<div class="typeahead-container">
    <div class="input-box" [class.focused]="isFocused">
        <rds-icon namespace="outlined" icon="search" class="search-icon"></rds-icon>
        <div class="chips-and-input" [class.focused]="isFocused">
            <div class="user-chip" *ngFor="let user of visibleUsers">
                <span class="chip-name">{{ getDisplayName(user) }}</span>
                <button class="chip-remove" (mousedown)="$event.preventDefault()" (click)="removeUser(user)" type="button">
                    <rds-icon namespace="outlined" icon="close"></rds-icon>
                </button>
            </div>
            <span 
                *ngIf="hiddenUsersCount > 0" 
                class="overflow-badge"
                [rdsTooltip]="hiddenUsersTooltip"
            >+{{ hiddenUsersCount }}</span>
            <input 
                type="text" 
                class="typeahead-input"
                [disabled]="disabled"
                [placeholder]="selectedUsers.length === 0 ? placeholder : ''"
                [value]="searchText"
                (input)="onInputChange($event)"
                (focus)="onInputFocus()"
                (blur)="onInputBlur()"
            />
        </div>
        <span *ngIf="isLoading" class="loading-spinner"></span>
    </div>

    <div class="suggestions-dropdown" *ngIf="showSuggestions">
        <div class="no-results" *ngIf="noResultsFound">
            No user found
        </div>
        <div 
            class="suggestion-item" 
            *ngFor="let user of getFilteredSuggestions()"
            (click)="selectUser(user)"
            [class.disabled-suggestion]="isExistedUser(user)"
            [rdsTooltip]="isExistedUser(user) ? 'User exists as a collaborator in the project' : ''"
            rdsTooltipPosition="top-left"
            (mousedown)="$event.preventDefault()"
        >
            <span 
                class="suggestion-avatar" 
                [rdsTooltip]="getDisplayName(user)"
            >{{ getInitials(user) }}</span>
            <div class="suggestion-info">
                <span class="suggestion-name">{{ getDisplayName(user) }}</span>
                <span class="suggestion-email">{{ user.email }}</span>
            </div>
        </div>
    </div>
</div>
